import $i18n from '@alife/panda-i18n';
import React, { useCallback, useEffect, useState } from 'react';
import { CnMessage, Form, Field, Grid, CnCard, CnAsyncSelect, CnButton, } from '@alife/cn-ui';
import { getCnVasPartnerInfo, saveCnVasPartnerInfo } from '../../api';
const { Row, Col } = Grid;
/**
 *  交货单--增值服务
 */
export default function CpForm(props) {
    const { asnCode, selfVasDetailList, handleSearch } = props;
    const field = Field.useField();
    const [values, setValues] = useState({});
    const [loading, setLoading] = useState(false);
    const [cpList, setCpList] = useState([]);
    // cp - 列表
    /** 获取cp信息 */
    const getCpList = useCallback(() => {
        getCnVasPartnerInfo({
            asnCode,
        }).then((res) => {
            const { data } = (res || {});
            setCpList((data?.cnVasPartnerInfoList || [])?.map((item) => {
                const { partnerCode, cnVasPartnerName, sourceSystem } = item;
                return {
                    label: cnVasPartnerName,
                    value: `${sourceSystem}${partnerCode}`,
                    ...item,
                };
            }));
        });
    }, [asnCode]);
    // 保存
    const handleSave = useCallback(() => {
        field.validate((error, value) => {
            if (error) {
                return;
            }
            setLoading(true);
            const { cnVasPartnerInfo } = value;
            const params = {
                asnCode,
            };
            const cnVasPartnerInfoItem = cpList?.find((one) => `${one.sourceSystem}${one.partnerCode}` === cnVasPartnerInfo);
            if (cnVasPartnerInfoItem) {
                params.cnVasPartnerInfo = cnVasPartnerInfoItem;
            }
            saveCnVasPartnerInfo(params)
                .then(() => {
                CnMessage.success($i18n.get({ id: 'SavedSuccessfully', dm: '保存成功' }));
                handleSearch();
            })
                .catch((err) => {
                CnMessage.error(err?.message);
                setValues({ cnVasPartnerInfo: null });
            })
                .finally(() => {
                setLoading(false);
            });
        });
    }, [asnCode, field, handleSearch, cpList]);
    useEffect(() => {
        getCpList();
    }, [getCpList]);
    useEffect(() => {
        if (selfVasDetailList?.[0]?.selfVasPartnerCode &&
            selfVasDetailList?.[0]?.selfVasPartnerSource) {
            const { selfVasPartnerSource, selfVasPartnerCode } = selfVasDetailList?.[0];
            setValues({
                cnVasPartnerInfo: `${selfVasPartnerSource}${selfVasPartnerCode}`,
            });
        }
        else {
            setValues({});
        }
    }, [selfVasDetailList, field]);
    return (React.createElement(CnCard, { title: $i18n.get({
            id: 'SelectLoadingAndUnloadingCP_1983152118',
            dm: '3.选择装卸CP',
        }), action: React.createElement(CnButton, { loading: loading, className: 'right-btn', type: 'secondary', onClick: handleSave }, $i18n.get({ id: 'Save', dm: '保存' })) },
        React.createElement(Form, { field: field, value: values },
            React.createElement(Row, { gutter: 8 },
                React.createElement(Col, { span: 12 },
                    React.createElement(Form.Item, { label: $i18n.get({
                            id: 'NameOfLoadingAndUnloadingCP_615747221',
                            dm: '装卸CP名称',
                        }), name: 'cnVasPartnerInfo' },
                        React.createElement(CnAsyncSelect, { showSearch: true, hasClear: true, dataSource: cpList, style: { width: '100%' }, onChange: (value, __unuse, item) => {
                                if (value) {
                                    const { sourceSystem, partnerCode } = item;
                                    setValues({
                                        cnVasPartnerInfo: `${sourceSystem}${partnerCode}`,
                                    });
                                }
                                else {
                                    setValues({});
                                }
                            } })))))));
}
